import React from "react";
import abs1 from "../../assets/Group39264.png";
import abs2 from "../../assets/white39265.png";
import Header3 from "../../components/Header/Header3";
import "./register.scss";
// import "../Login/login.scss";

function Registered() {
  return (
    <div className="registerMainDiv">
      <Header3 />
      <div className="request_section_Register">
        <div className="request_content">
          <div className="form">
            <div className="title">
              <h2>
                <div className="abs1">
                  <img src={abs1} alt="" />
                </div>
                Playground for the world’s <span>0.01%</span>
              </h2>
              <div className="info">
                <div className="rectangle"></div>
                <p>
                  <p
                    className=" 
                 title2
                "
                  >
                    Rare opportunities. Rare access. Rarer people.
                  </p>
                  <div className="abs2">
                    <img src={abs2} alt="" />
                  </div>
                </p>
              </div>
            </div>
            <div
              className="form_wrapper"
              // style={{
              //   marginBottom: "12rem",
              // }}
            >
              <p className="registerTagHeading">
                Welcome to <span className="headingRegister">Ballers</span>{" "}
              </p>
              <p className="tagLine">We're thrilled to have you onboard.</p>
              <br />
              <p className="registerTag">
                Please{" "}
                <a href="/login" className="link">
                  login
                </a>{" "}
                to your dashboard to start investing in Sports Assets and
                contribute to the success of promising athletes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registered;
